import React from "react";
import { Flag } from "../../lib/countries";

function StatusBadge({ classification }) {
  const unresolved = /unresolved/i.test(classification);
  return (
    <span
      className={`inline-flex items-center gap-1.5 border px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest ${
        unresolved
          ? "border-amber-500/50 text-amber-400 bg-amber-500/5"
          : "border-emerald-500/50 text-emerald-400 bg-emerald-500/5"
      }`}
    >
      <span
        className={`h-1.5 w-1.5 rounded-full ${
          unresolved ? "bg-amber-400 animate-pulse-amber" : "bg-emerald-400"
        }`}
      />
      {unresolved ? "Unresolved" : "Resolved"}
    </span>
  );
}

export default function CaseTable({ cases, onSelect, activeCaseId }) {
  return (
    <div
      data-testid="case-table"
      className="border border-zinc-800 bg-zinc-950 overflow-hidden"
    >
      <div className="overflow-auto max-h-[520px]">
        <table className="w-full text-left">
          <thead className="sticky top-0 bg-zinc-950 z-10">
            <tr className="border-b border-zinc-800">
              {[
                "Case ID",
                "Agency",
                "Incident Date",
                "Location",
                "Type",
                "Sensor",
                "Status",
              ].map((h) => (
                <th
                  key={h}
                  className="px-4 py-2.5 font-mono text-[10px] uppercase tracking-widest text-zinc-500 font-medium"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {cases.length === 0 && (
              <tr>
                <td
                  colSpan={7}
                  className="px-4 py-10 text-center font-mono text-xs text-zinc-500"
                >
                  NO RECORDS · ADJUST FILTERS
                </td>
              </tr>
            )}
            {cases.map((c) => (
              <tr
                key={c.case_id}
                onClick={() => onSelect(c)}
                data-testid={`case-row-${c.case_id}`}
                className={`border-b border-zinc-900 cursor-pointer transition-colors ${
                  activeCaseId === c.case_id
                    ? "bg-amber-500/5"
                    : "hover:bg-zinc-900/60"
                }`}
              >
                <td className="px-4 py-2.5 font-mono text-xs text-amber-400 whitespace-nowrap">
                  {c.case_id}
                </td>
                <td className="px-4 py-2.5 font-mono text-xs text-zinc-300 whitespace-nowrap">
                  {c.agency}
                </td>
                <td className="px-4 py-2.5 font-mono text-xs text-zinc-400 whitespace-nowrap tabular-nums">
                  {c.incident_date}
                </td>
                <td className="px-4 py-2.5 text-sm text-zinc-200">
                  <span className="inline-flex items-center gap-2">
                    <Flag country={c.country} />
                    {c.location}
                  </span>
                </td>
                <td className="px-4 py-2.5 font-mono text-xs text-zinc-400 whitespace-nowrap">
                  {c.type}
                </td>
                <td className="px-4 py-2.5 font-mono text-[11px] text-zinc-500 whitespace-nowrap">
                  {c.sensor}
                </td>
                <td className="px-4 py-2.5">
                  <StatusBadge classification={c.classification} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
